import React from 'react';

interface IProps {
  fillColor?: string;
}

const MoveTopIcon:React.FC<IProps> = (props) => {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.767567 1.53516L16.1197 1.53516C16.5437 1.53516 16.8873 1.19149 16.8873 0.767549C16.8873 0.343611 16.5437 -5.91278e-05 16.1197 -5.91278e-05L0.767567 -5.91278e-05C0.34363 -5.91278e-05 -4.00543e-05 0.343611 -4.00543e-05 0.767549C-4.00543e-05 1.19149 0.34363 1.53516 0.767567 1.53516Z" fill={props.fillColor ?? "#424C57"}/>
      <path d="M6.14077 16.8867H10.7464C11.3823 16.8867 11.8978 16.3712 11.8978 15.7353L11.8978 4.22119C11.8978 3.58529 11.3823 3.06978 10.7464 3.06978H6.14077C5.50486 3.06978 4.98936 3.58529 4.98936 4.22119L4.98936 15.7353C4.98936 16.3712 5.50486 16.8867 6.14077 16.8867Z" fill={props.fillColor ?? "#424C57"}/>
    </svg>
  )
}

export default MoveTopIcon;
